/*
The component that composed of both the file uploader and template
selector
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'antd';
import 'antd/dist/antd.css'

import FileSelectScreen from './FileSelectScreen';
import { uploadPdfs, selectTemplates } from '../actions';

class WordSetUploader extends Component {
  constructor() {
    super();

    this.state = {
      Templates: [
        { value: 'biologies', label: 'Biology' },
        { value: 'machine_learnings', label: 'Machine Learning' },
        { value: 'businesses', label: 'Business' }
      ]
    };
  }

  render() {
    return (
      <div className="imitator-pane">
        <div className="input-bar">
          <Select
            closeMenuOnSelect={false}
            isMulti
            options={this.state.Templates}
            // adding the options selected into the
            // template list in App
            onChange={opts => this.props.selectTemplates(opts)}
          />
          <Button
            className="btn"
            onClick={event => {
              this.props.uploadPdfs([], this.props.TemplatesSelected, res => {
                alert('Finished Processing');
              });
            }}>
            I Just Want to Use Templates!
          </Button>
        </div>
        <div>
          <FileSelectScreen Templates={this.props.TemplatesSelected} />
        </div>
      </div>
    );
  }
}

WordSetUploader.propTypes = {
  TemplatesSelected: PropTypes.array,
  uploadPdfs: PropTypes.func,
  selectTemplates: PropTypes.func
};

function mapStateToProps(state) {
  return { TemplatesSelected: state.TemplatesSelected };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadPdfs: uploadPdfs,
      selectTemplates: selectTemplates
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WordSetUploader);



// WEBPACK FOOTER //
// ./src/containers/WordSetUploader.js